document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.hash.replace('#', ''));

    const tab = params.get('tab');
    const spec = params.get('spec');

    // Open main tab + scroll to section
    if (tab) {
        const tabEl = document.querySelector(`[data-deeplink-tab="${tab}"]`);

        if (tabEl) tabEl.click();

        setTimeout(() => {
            const section = document.querySelector('.specifications');

            if (section) {
                const headerOffset = 510;
                const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition + headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }, 150);
    }

    // Open spec tab
    if (spec) {
        const tabEl = document.querySelector('[data-deeplink-tab="specifications"]');
        const specEl = document.querySelector(`[data-deeplink-spec="${spec}"]`);

        if (tabEl) tabEl.click();
        if (specEl) specEl.click();
    }

    // Update URL on tab click
    document.querySelectorAll('[data-deeplink-tab]').forEach(el => {
        el.addEventListener('click', () => {
        const params = new URLSearchParams();
        params.set('tab', el.dataset.deeplinkTab);
        window.history.replaceState(null, '', `#${params}`);
        });
    });

    // Update URL on spec click
    document.querySelectorAll('[data-deeplink-spec]').forEach(el => {
        el.addEventListener('click', () => {
        const params = new URLSearchParams();
        params.set('tab', 'specifications');
        params.set('spec', el.dataset.deeplinkSpec);
        window.history.replaceState(null, '', `#${params}`);
        });
    });
});